import _resolvedAndErrorContentQuery from "./__generated__/resolvedAndErrorContentQuery.graphql";
import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { graphql, useLazyLoadQuery } from 'react-relay';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import PageIcon from '@atlaskit/icon/core/page';
import { EmptyState, ResultContainer, SearchDialogContent, SearchResult } from '@atlassian/search-dialog';
import { useArticleSearch } from '../../../../controllers/use-article-search';
import { ContentType } from '../../types';
import { SearchErrorImage } from './error-image';
import { messages } from './messages';
export var ResolvedAndErrorContent = function ResolvedAndErrorContent(_ref) {
  var cloudId = _ref.cloudId,
    helpCenterAri = _ref.helpCenterAri,
    queryWord = _ref.queryWord;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  /* eslint-disable @atlassian/relay/unused-fields */
  var searchResponse = useLazyLoadQuery(_resolvedAndErrorContentQuery, {
    cloudId: cloudId,
    helpCenterAri: helpCenterAri,
    input: {
      query: queryWord,
      contentTypes: ['FOLDER', 'PAGE']
    },
    first: 10
  });

  /* eslint-enable @atlassian/relay/unused-fields */
  var _useArticleSearch = useArticleSearch(searchResponse, queryWord),
    articlesAndFolders = _useArticleSearch.articlesAndFolders,
    hasQueryError = _useArticleSearch.hasQueryError;
  var showEmptyState = articlesAndFolders && articlesAndFolders.length === 0;
  var showResolvedState = articlesAndFolders && articlesAndFolders.length > 0;
  return /*#__PURE__*/React.createElement(Fragment, null, (showEmptyState || hasQueryError) && /*#__PURE__*/React.createElement(EmptyState, {
    title: hasQueryError ? formatMessage(messages.errorTitle) : formatMessage(messages.emptyStateTitle),
    Image: SearchErrorImage,
    content: hasQueryError ? /*#__PURE__*/React.createElement(FormattedMessage, messages.errorDescription) : /*#__PURE__*/React.createElement(FormattedMessage, messages.emptyStateDescription)
  }), showResolvedState && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchDialogContent, null, /*#__PURE__*/React.createElement(ResultContainer, null, articlesAndFolders.map(function (result) {
    return /*#__PURE__*/React.createElement(SearchResult, {
      key: result.id,
      href: result.url,
      title: result.title,
      isCollapsed: true,
      icon: result.type === ContentType.PAGE ? /*#__PURE__*/React.createElement(PageIcon, {
        label: ""
      }) : /*#__PURE__*/React.createElement(FolderClosedIcon, {
        label: ""
      })
    });
  })))));
};